import type { CSSProperties } from 'react';

// The pill the canvas controls float in.
export const floatingControlStyle: CSSProperties = {
  position: 'absolute',
  bottom: 16,
  zIndex: 10,
  display: 'flex',
  alignItems: 'center',
  padding: 4,
  borderRadius: 'var(--pf-radius-md)',
  border: '0.5px solid var(--pf-color-soft-pearl-300)',
  background: 'var(--pf-color-background)',
  boxShadow: 'var(--pf-shadow-raised)',
};
